import { Text } from "@easy-email-pro-core/blocks/basic/Text";
import { StandardType } from "@easy-email-pro-core/constants";
import {
  StandardH1Element,
  StandardH2Element,
  StandardH3Element,
  StandardH4Element,
  StandardParagraphElement,
  StandardTextElement,
} from "@easy-email-pro-core/typings";
import { mergeBlock, t } from "@easy-email-pro-core/utils";
import { cloneDeep } from "lodash";
import { generateTextBlock } from "./generateTextBlock";

const textBlock = cloneDeep(Text.defaultData);

export const StandardText = generateTextBlock<StandardTextElement>(
  {
    get name() {
      return t(`Text`);
    },
    type: StandardType.STANDARD_TEXT,
    data: {},
    attributes: {},
    children: [
      {
        text: t("This is a text block. Click here to edit it..."),
      },
    ],
  },
  mergeBlock(textBlock, {
    attributes: {},
    data: {},
  })
);

export const StandardParagraph = generateTextBlock<StandardParagraphElement>(
  {
    get name() {
      return t(`Text`);
    },
    type: StandardType.STANDARD_PARAGRAPH,
    data: {},
    attributes: {},
    children: [
      {
        text: t("This is a text block. Click here to edit it..."),
      },
    ],
  },
  mergeBlock(textBlock, {
    attributes: {
      "letter-spacing": "0px",
      "padding-top": "3px",
      "padding-bottom": "3px",
      "padding-left": "25px",
      "padding-right": "25px",
      "font-size": "16px",
      "line-height": "1.3",
      "font-weight": "normal",
      align: "center",
    },
    data: {},
  })
);

export const StandardHeading1 = generateTextBlock<StandardH1Element>(
  {
    get name() {
      return t(`Heading 1`);
    },
    type: StandardType.STANDARD_H1,
    data: {},
    attributes: {},
    children: [
      {
        text: t("This is a text block. Click here to edit it..."),
      },
    ],
  },
  mergeBlock(textBlock, {
    attributes: {
      "letter-spacing": "0px",
      "padding-top": "3px",
      "padding-bottom": "3px",
      "padding-left": "25px",
      "padding-right": "25px",
      "font-size": "40px",
      "line-height": "130%",
      "font-weight": "600",
      align: "center",
    },
    data: {},
  })
);

export const StandardHeading2 = generateTextBlock<StandardH2Element>(
  {
    get name() {
      return t(`Heading 2`);
    },
    type: StandardType.STANDARD_H2,
    data: {},
    attributes: {},
    children: [
      {
        text: t("This is a text block. Click here to edit it..."),
      },
    ],
  },
  mergeBlock(textBlock, {
    attributes: {
      "letter-spacing": "0px",
      "padding-top": "3px",
      "padding-bottom": "3px",
      "padding-left": "25px",
      "padding-right": "25px",
      "font-size": "32px",
      "line-height": "130%",
      "font-weight": "600",
      align: "center",
    },
    data: {},
  })
);

export const StandardHeading3 = generateTextBlock<StandardH3Element>(
  {
    get name() {
      return t(`Heading 3`);
    },
    type: StandardType.STANDARD_H3,
    data: {},
    attributes: {},
    children: [
      {
        text: t("This is a text block. Click here to edit it..."),
      },
    ],
  },
  mergeBlock(textBlock, {
    attributes: {
      "letter-spacing": "0px",
      "padding-top": "3px",
      "padding-bottom": "3px",
      "padding-left": "25px",
      "padding-right": "25px",
      "font-size": "24px",
      "line-height": "130%",
      "font-weight": "600",
      align: "center",
    },
    data: {},
  })
);

export const StandardHeading4 = generateTextBlock<StandardH4Element>(
  {
    get name() {
      return t(`Heading 4`);
    },
    type: StandardType.STANDARD_H4,
    data: {},
    attributes: {},
    children: [
      {
        text: t("This is a text block. Click here to edit it..."),
      },
    ],
  },
  mergeBlock(textBlock, {
    attributes: {
      "letter-spacing": "0px",
      "padding-top": "3px",
      "padding-bottom": "3px",
      "padding-left": "25px",
      "padding-right": "25px",
      "font-size": "18px",
      "line-height": "130%",
      "font-weight": "600",
      align: "center",
    },
    data: {},
  })
);
